import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import AdminSidebar from "../../../component/AdminComp/AdminSidebar";
import AdminTopbar from "../../../component/AdminComp/AdminTopbar";
import { baseurl } from "../../../Baseurl"; // Ensure this is correctly defined

const EditAdmin = () => {
  const { id } = useParams(); // Get admin ID from URL
  const navigate = useNavigate(); // For redirection

  const [selectedAdmin, setSelectedAdmin] = useState({
    adminName: "",
    email: "",
    password: "",
    role: "",
    modules: [],
  });

//   const [availableModules, setAvailableModules] = useState([]);  
  const [loading, setLoading] = useState(true);


  // Available modules (checkbox options)
const availableModules = [
  { 
    id: 1, 
    name: "Dashboard", 
    routes: ["/admin/dashboard", "/admin/seller-list-cost", "/admin/review", "/admin/direct-purchase", "/admin/all-enquiry", "/admin/contact", "/admin/seller-quote"] 
  },
  { 
    id: 2, 
    name: "Manage Website", 
    routes: ["/admin/item-category", "/admin/all-category", "/admin/all-trash-category", "/admin/all-service-category", "/admin/all-service-request", "/admin/full-banner", "/admin/all-coupon", "/admin/approve-listing", "/admin/all-approved-listing", "/admin/all-rejected-listing", "/admin/download"] 
  },
  { 
    id: 3, 
    name: "Report / Product listing", 
    routes: ["/admin/seller-report", "/admin/all-sellers", "/admin/all-customer", "/admin/all-listings", "/admin/education-category", "/admin/add-education", "/admin/all-education"] 
  },
  { 
    id: 4, 
    name: "Orders", 
    routes: ["/admin/all-orders", "/admin/ship-to"] 
  },
  { 
    id: 5, 
    name: "Blog Management", 
    routes: ["/admin/add-blog-category", "/admin/add-blog", "/admin/blog-list"] 
  }
];
  


  // Fetch Admin Data By ID
  useEffect(() => {
    const fetchAdminData = async () => {
      try {
        const response = await axios.get(`${baseurl}FetchAdminDataById/${id}`);
        if (response.data.admin) {
          const adminData = response.data.admin;
          setSelectedAdmin({
            adminName: `${adminData.first_name} ${adminData.last_name}`,
            email: adminData.admin_email,
            password: "", // Keep password field empty for security reasons
            role: adminData.role,
            modules: adminData.modules || [],
          });
        }
        setLoading(false);
      } catch (error) {
        console.error("Error fetching admin data:", error);
        setLoading(false);
      }
    };

    fetchAdminData();
  }, [id]);

  // Handle form input change
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setSelectedAdmin((prevAdmin) => ({
      ...prevAdmin,
      [name]: value,
    }));
  };

// Handle module selection change
const handleModuleChange = (module) => {
    setSelectedAdmin((prevAdmin) => {
      // Parse stored modules into objects
      let updatedModules = prevAdmin.modules.map((mod) =>
        typeof mod === "string" ? JSON.parse(mod) : mod
      );
  
      // Check if the module is already selected
      const isModuleSelected = updatedModules.some((mod) => mod.id === module.id);
  
      if (isModuleSelected) {
        // Remove module if already selected
        updatedModules = updatedModules.filter((mod) => mod.id !== module.id);
      } else {
        // Add module if not selected
        updatedModules.push(module);
      }
  
      return { ...prevAdmin, modules: updatedModules };
    });
  };
  

  // Handle form submission (Update Admin Data)
  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("Form submission triggered!"); // Debugging step
  
    try {
      const payload = {
        id: id,
        first_name: selectedAdmin.adminName.split(" ")[0],
        last_name: selectedAdmin.adminName.split(" ")[1] || "",
        admin_email: selectedAdmin.email,
        password: selectedAdmin.password || undefined, // Avoid sending empty passwords
        role: selectedAdmin.role,
        modules: selectedAdmin.modules,
      };
  
      console.log("Payload being sent:", JSON.stringify(payload, null, 2));
  
      await axios.post(`${baseurl}UpdateAdminDataById`, payload);
  
      Swal.fire({
        icon: "success",
        title: "Updated Successfully",
        text: "Admin details have been updated!",
      });
  
      navigate("/add-admin");  
    } catch (error) {
      console.error("Error updating admin:", error);
      Swal.fire({
        icon: "error",
        title: "Update Failed",
        text: "Something went wrong!",
      });
    }
  };
  
  return (
    <div className="App" style={{ display: "flex" }}>
      <AdminSidebar />
      <div className="content" style={{ flexGrow: 1, padding: "20px" }}>
        <AdminTopbar />
        <div className="container-fluid">
          <h4 className="text-start">Edit Admin</h4>

          {loading ? (
            <p>Loading...</p>
          ) : (
            <form onSubmit={handleSubmit}>
              <div className="mb-3 text-start">
                <label htmlFor="adminName" className="form-label">Admin Name</label>
                <input
                  type="text"
                  className="form-control"
                  name="adminName"
                  placeholder="Enter Admin Name"
                  value={selectedAdmin.adminName}
                  onChange={handleInputChange}
                  required
                />
              </div>

              <div className="mb-3 text-start">
                <label htmlFor="email" className="form-label">Email</label>
                <input
                  type="email"
                  className="form-control"
                  name="email"
                  placeholder="Enter Email"
                  value={selectedAdmin.email}
                  onChange={handleInputChange}
                  required
                />
              </div>

              <div className="mb-3 text-start">
                <label htmlFor="password" className="form-label">Password</label>
                <input
                  type="password"
                  className="form-control"
                  name="password"
                  placeholder="Enter New Password (Leave blank to keep old password)"
                  value={selectedAdmin.password}
                  onChange={handleInputChange}
                />
              </div>

              <div className="mb-3 text-start">
                <label className="form-label">Role</label>
                <select
                  className="form-select"
                  name="role"
                  value={selectedAdmin.role}
                  onChange={handleInputChange}
                  required
                >
                  <option value="">Select Role</option>
                  <option value="super-admin">Super Admin</option>
                  <option value="admin">Admin</option>
                </select>
              </div>

              <div className="mb-3 text-start">
  <label className="form-label">Modules</label>
  {availableModules.map((module) => {
    // Parse stored modules into objects
    const selectedModuleIds = selectedAdmin.modules.map((mod) =>
      typeof mod === "string" ? JSON.parse(mod).id : mod.id
    );

    return (
      <div key={module.id} className="form-check">
        <input
          type="checkbox"
          className="form-check-input"
          checked={selectedModuleIds.includes(module.id)}
          onChange={() => handleModuleChange(module)}
        />
        <label className="form-check-label">{module.name}</label>
      </div>
    );
  })}
</div>



              <div className="text-end">
                <button type="submit" className="btn submitbtnn">Save</button>
              </div>
            </form>
          )}
        </div>
      </div>
    </div>
  );
};

export default EditAdmin;
